//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavCogFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.9 8.90001C19.12 8.45001 18.64 7.62001 18.64 6.72001L18.65 4.30001L15.35 2.40001L13.26 3.62001C12.48 4.07001 11.52 4.07001 10.74 3.62001L8.65 2.39001L5.36 4.29001L5.37 6.71001C5.37 7.61001 4.89 8.44001 4.11 8.89001L2 10.1V13.91L4.1 15.11C4.88 15.56 5.36 16.39 5.36 17.29L5.35 19.71L8.65 21.61L10.74 20.39C11.52 19.94 12.48 19.94 13.26 20.39L15.35 21.61L18.64 19.71L18.63 17.29C18.63 16.39 19.11 15.56 19.89 15.11L21.99 13.91V10.1L19.9 8.90001ZM12 16C9.79 16 8 14.21 8 12C8 9.79001 9.79 8.00001 12 8.00001C14.21 8.00001 16 9.79001 16 12C16 14.21 14.21 16 12 16Z" fill="currentColor" /></svg>;
}
export default IconNavCogFill;